<script>
    import {onMount} from 'svelte'
    import smoothscroll from 'smoothscroll-polyfill';
    import Centering from '../layouts/CenteringInner.svelte'
    import Slider from '../components/Slider.svelte'
    smoothscroll.polyfill();
    document.addEventListener("click", e => {
      const target = e.target;
      if (!target.classList.contains("smooth-scroll")) return;
      e.preventDefault();
      const targetId = target.hash;

      document.querySelector(targetId).scrollIntoView({
        behavior: "smooth"
      });
    });
    onMount(()=>{
    })
</script>
<div>
    <div class="header">
        <div class="header-inner">
            <a href="/contact"><img src="/img/contact.png" alt=""></a>
            <a class="smooth-scroll" href="#purchase"><img src="/img/purchase.png" alt=""></a>
        </div>
    </div>
    <div class="fv" id="fv">
        <img src="/img/fv.png" alt="">
    </div>
    <div class="about">
        <div class="inner">
            <div class="about-img">
                <img src="/img/about1.png" alt="">
            </div>
            <div class="about-txt">
                <p class="about-txt1">
                    こだわり３層構造で、広げない。通さない。荒れさせない。
                </p>
                <p class="about-txt2">
                    肌のあらゆる悩みに<br>
                    対応したマスクが
                </p>
                <p class="about-txt3">
                    新しく生まれ変わりました!
                </p>
                <p class="about-txt4">肌に直接触れる内側層に≪人工シルク≫と≪ヒアルロン酸≫を配合し、飛沫防止性能と通気性、肌触りを両立。プレミアムな、まさに≪無敵≫のマスクです。</p>
            </div>
        </div>
    </div>
    <div class="feature">
        <div class="inner">
            <img src="/img/feature1.png" alt="">
        </div>
    </div>
    <div class="silk">
        <div class="inner">
            <div class="silk-txt">
                <p class="silk-txt1">あなたの肌を守る</p>
                <p class="silk-txt2">人工シルク<span>と</span>ヒアルロン酸</p>
                <p class="silk-txt3">「マスクを長時間つけていると肌が荒れる。」
                    そんな方にこそ、無敵マスク。
                    きめ細かく肌触りの良い人工シルクと
                    肌に優しいヒアルロン酸を配合した内側層が、あなたの肌を守ります。</p>
            </div>
        </div>
    </div>
    <div class="material">
        <div class="inner">
            <div class="material-img">
                <img src="/img/material1.png" alt="">
            </div>
            <div class="material-txt">
                <p class="material-txt1">通気性<span>を追求した素材</span></p>
                <p class="material-txt2">肌に優しい、だけじゃない。
                    無敵マスクは、特殊印刷の技術を応用した、息苦しさを感じにくいマスクです。
                    呼吸しやすいオリジナル素材の使用により、高い通気性を確保しています。</p>
            </div>
        </div>
    </div>
    <div class="function">
        <div class="inner">
            <div class="function-img">
                <img src="/img/function1.png" alt="">
            </div>
        </div>
    </div>
    <div class="faq">
        <div class="inner">
            <div class="faq-img">
                <img src="/img/faq1.png" alt="">
            </div>
            <div class="faq-txt">
                <p class="faq-txt1">こんなお悩みを・・・</p>
                <p class="faq-txt2">無敵マスク<span>で改善できます！</span></p>
                <p class="faq-txt3">「肌荒れしにくいマスク」「化粧崩れしにくいマスク」
                    「息苦しくなりにくいマスク」
                    こんなマスクがあったらいいな、と思ったことはありませんか？
                    無敵マスクは、そんなあなたにとって理想のマスクです。</p>
            </div>
        </div>
    </div>
    <div class="story">
        <div class="inner">
            <div class="story-img1">
                <img src="/img/story1.png" alt="">
            </div>
            <div class="story-txt">
                <img src="/img/story_txt.png" alt="">
            </div>
            <div class="story-img2">
                <img src="/img/story2.png" alt="">
            </div>
            <a class="story-btn" href="https://www.sankosangyo.co.jp/" target="_blank">
                三光産業の公式サイトに飛ぶ <span><img src="/img/window-btn.svg" alt=""></span>
            </a>
            <div class="story-img3">
                <img src="/img/story3.png" alt="">
            </div>
        </div>
        <div class="story-img4">
            <img src="/img/story4.png" alt="">
        </div>
    </div>
    <div class="comment">
        <div class="comment-img">
            <img src="/img/comment1.png" alt="">
        </div>
        <div class="comment-slider">
            <Slider/>
        </div>
    </div>
    <div class="product">
        <div class="inner">
            <div class="product-img1">
                <img src="/img/product1.png" alt="">
            </div>
            <div class="product-list">
                <div class="product-item">
                    <img src="/img/product_item1.png" alt="">
                    <div class="item-txt">
                        <p class="item1">ナノAG＋ AIRマスク</p>
                        <p class="item2">シルキーフィットプレミアム</p>
                        <p class="item3">SILKY FIT premium</p>
                        <p class="item4">ふつう<span>サイズ</span></p>
                        <p class="item5">個包装30枚入り</p>
                        <p class="item6">3,278円（税込）</p>
                    </div>
                </div>
                <div class="product-item silver">
                    <img src="/img/product_item2.png" alt="">
                    <div class="item-txt">
                        <p class="item1">ナノAG＋ AIRマスク</p>
                        <p class="item2">シルキーフィットプレミアム</p>
                        <p class="item3">SILKY FIT premium</p>
                        <p class="item4">小さい<span>サイズ</span></p>
                        <p class="item5">個包装30枚入り</p>
                        <p class="item6">3,278円（税込）</p>
                    </div>
                </div>
                <div class="product-item">
                    <img src="/img/product_item3.png" alt="">
                    <div class="item-txt">
                        <p class="item1">ナノAG＋ AIRマスク</p>
                        <p class="item2">シルキーフィットプレミアム</p>
                        <p class="item3">SILKY FIT premium</p>
                        <p class="item4">ふつう<span>サイズ</span></p>
                        <p class="item5">個包装4枚入り</p>
                        <p class="item6">548円（税込）</p>
                    </div>
                </div>
                <div class="product-item silver">
                    <img src="/img/product_item4.png" alt="">
                    <div class="item-txt">
                        <p class="item1">ナノAG＋ AIRマスク</p>
                        <p class="item2">シルキーフィットプレミアム</p>
                        <p class="item3">SILKY FIT premium</p>
                        <p class="item4">小さい<span>サイズ</span></p>
                        <p class="item5">個包装4枚入り</p>
                        <p class="item6">548円（税込）</p>
                    </div>
                </div>
            </div>
            <div class="product-button" id="purchase">
                <a href="https://sankostore.com/collections/%E3%83%8A%E3%83%8Eag-air%E3%83%9E%E3%82%B9%E3%82%AF" target="_blank">
                    <span class="button-inner">
                        ご購入はこちら
                        <img src="/img/btn-img.png" alt="">
                    </span>
                </a>
                <p>※無敵マスクのECサイトに飛びます。</p>
            </div>
        </div>
    </div>
    <div class="footer">
        <img src="/img/footer_logo.svg" alt="">
        <p>Copyright © 2021 SANKO SANGYO CO.,LTD. All Right Reservrd.</p>
    </div>
</div>
<style>
    .header{
        position:fixed;
        z-index:20000;
        right:20px;
        bottom:20px;    
    }
    .header-inner{
        display: flex;
        flex-direction: column;
    }
    .header a{
        transition:opacity .5s;
    }
    .header a:hover{
        transition:opacity .5s;
        opacity:.5
    }
    p{
        margin: 0;
    }
.inner{
    width:1280px;
    margin:0 auto;
    position: relative;
}

.fv{
    display:flex;
    min-width:1280px;
    width:100%;
    height:auto;
}
.fv img{
    min-width:1280px;
    width:100%;
    height:auto;
}
.about{
    width:100%;
    display:flex;
    min-width:1280px;
    margin:0 auto;
    height:588px;
    background-color: #FDFDFC;
}
.about .inner{
    display: flex;
}
.about-img{
    margin-top: 128px;;
}
.about-txt{
    margin-top: 128px;
    margin-left: 58px;;
}
.about-txt1{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #b7a582;
    text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.78);
}
.about-txt2{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 35px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #433a2c;
    margin-top: 19px;;
}
.about-txt3{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 50px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #b29a74;
    margin-top: 7px;
}
.about-txt4{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #433a2c;
    text-shadow: 0px 0px 10px #fff;
    width:542px;
    margin-top: 41px;;
}
.feature{
    width:100%;
    display:flex;
    min-width:1280px;
    margin:0 auto;
    height:890px;
    background-image: url(/img/feature_bg.png);
    background-size: 100% 100%;
}
.feature img{
    display:block;
    margin: auto;
    margin-top: 80px;
}
.silk{
    width:100%;
    display:flex;
    min-width:1280px;
    margin:0 auto;
    height:580px;
    background-image: url(/img/silk_bg.png);
    background-size:100% 100%;
}
.silk-txt{
    margin-top: 90px;
    background-image: url(/img/silk1.png);
    width:703px;
    height:330px;
}
.silk-txt1{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #b7a582;
    text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.78);
    padding-top: 54px;
    margin-left: 49px;;
}
.silk-txt2{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 50px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #433a2c;
    text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.78);
    padding-top: 7px;
    margin-left: 49px;;
}
.silk-txt2 span{
    font-size: 35px;
}
.silk-txt3{
    width: 614px;
    white-space: pre-line;
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #433a2c;
    text-shadow: 0px 0px 10px #fff;
    padding-top: 28px;
    margin-left: 49px;;
}
.material{
    width:100%;
    display:flex;
    min-width:1280px;
    margin:0 auto;
    height:690px;
    background-image: url(/img/material_bg.png);
    background-size: cover;
    position: relative;
}
.material-img{
    margin-top: 214px;
    margin-left: 78px;;
}
.material-txt{
    position: absolute;
    top: 163px;
    left: 630px;
}
.material-txt1{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 50px;
    letter-spacing: 0.06em;
    color: #433a2c;
    margin-left: 8px;
}
.material-txt1 span{
    font-size: 35px;
}
.material-txt2{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #433a2c;
    text-shadow: 0px 0px 10px #fff;
    width:432px;
    white-space: pre-line;
    margin-top: 41px;
}
.function{
    width:100%;
    display:flex;
    min-width:1280px;
    margin:0 auto;
    height:924px;
    background-color: #F9F6F2;
}
.function img{
    display:block;
    margin: auto;
    margin-top: 80px;
}
.faq{
    width:100%;
    display:flex;
    min-width:1280px;
    margin:0 auto;
    height:563px;
    background-color: #FDFDFC;
}
.faq-img{
    margin-top: 80px;
    margin-left: 27px;;
}
.faq-txt{
    position: absolute;
    top: 140px;
    left: 630px;
}
.faq-txt1{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 35px;
    letter-spacing: 0.06em;
    color: #433a2c;
    margin-left: 45px;
}
.faq-txt2{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 50px;
    letter-spacing: 0.06em;
    color: #433a2c;
    margin-left: 29px;
    margin-top: 18px;
}
.faq-txt2 span{
    font-size: 35px;
}
.faq-txt3{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.06em;
    text-align: left;
    color: #433a2c;
    text-shadow: 0px 0px 10px #fff;
    white-space: pre-line;
    margin-top: 32px;
}
.story{
    width: 100%;
    height: 2401.41px;
    background:url(/img/story_bg.png);
    background-size: 100% 100%;
}
.story-btn{
    margin: auto;
    margin-top: 58px;
    display:flex;
    width: 299px;
    height: 47.08px;
    border-radius: 23.54px;
    background: #b7a582;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    text-decoration: none;
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #fdfdfc;
    align-items: center;
    padding-left: 45px;
    position: relative;
    transition:opacity .5s;
}
.story-btn:hover{
    opacity:0.5;
}
.story-btn span{
    position: absolute;
    top:13px;
    right:17px;
}
.story-img1{
    display: block;
    margin: auto;
    padding-top: 80px;
    width:212px;
}
.story-img2{
    margin-top: 123px;
}
.story-img3 {
    display: block;
    margin:auto;
    margin-left: 145px;;
    margin-top: 34px;
}
.story-img4{
    width:1400px;
    max-width:100%;
    margin: auto;
    display: block;
}
.story-img4 img{
    width:100%;
}
.story-txt{
    position:absolute;
    top:223px;
    left:976px;
}
.comment{
    width: 100%;
    height: 880px;
    background:#FCFCFC;
    margin-top: -2px;;
}
.comment-img img{
    width:662px;
    margin: auto;
    display: block;
    padding-top: 80px;
}
.product{
    width:100%;
    display:flex;
    min-width:1280px;
    margin:0 auto;
    height:1090px;
    background-image: url(/img/product_bg.png);
    background-size: 100% 100%;
    position: relative;
}
.product-img1{
    margin: auto;
    margin-top: 80px;
    display: block;;
    width:240px;
}
.product-list{
    margin: auto;
    margin-top: 41px;;
    display: flex;
    width:1190px;
    height:630px;
    justify-content: space-between;
    align-content: space-between;
    flex-wrap: wrap;
    position: relative;
}
.product-item{
    width: 580px;
    height: 300px;
    border-radius: 20px;
    background: #FEFEFD;
    box-shadow: 0px 6px 20px rgba(70, 66, 59, 0.08);
    position: relative;
}
.product-item img{
    margin-left: 36px;
    margin-top: 48px;;
}
.product-item .item-txt{
    position: absolute;
    left:347px;
    top:41px;
}
.item1{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #433a2c;
}
.item2,.item3{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #b7a582;
}
.item4{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 25px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #433a2c;
    margin-top: 22px;
}
.item4 span,.item5,.item6{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #433a2c;
    position: relative;
}
.item5,.item6{
    margin-top: 27px;
}
.item5:before,.item6:before{
    content:"";
    display: block;
    position: absolute;
    top:-12px;
    width: 193px;
    height: 2px;
    border-radius: 1px;
    background: linear-gradient(#f4dfa6 0%, #aba08b 100%);
}
.silver .item5:before,.silver .item6:before{
    content:"";
    display: block;
    position: absolute;
    top:-12px;
    width: 193px;
    height: 2px;
    border-radius: 1px;
    background: linear-gradient(#e8e8e8 0%, #99a2a3 100%);
}
.silver .item2,.silver .item3{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #B0B6B7;
}
.product-button a{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 469px;
    height: 88px;
    border-radius: 10px;
    background: linear-gradient(#f3dea6 0%, #aa9f8b 100%);
    box-shadow: 0px 3px 10px rgba(56, 54, 52, 0.25);
    text-decoration: none;
    position: relative;
    margin: auto;
    margin-top: 60px;;
    
    transition:all .5s;
}
.product-button a:hover{
    opacity:0.5;
    transition:all .5s;
}
.product-button p{
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #433a2c;
    margin-top: 16px;;
}
.button-inner{
    width: 455px;
    height: 76px;
    border-radius: 10px;
    background: #fff;
    font-family: "Noto Serif JP";
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 0.06em;
    text-align: center;
    color: #b29a74;
    text-decoration: none;
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
}
.button-inner img{
    position: absolute;
    right:20px;
}
.footer{
  width: 100%;
  min-width:1280px;
  height: 204px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer img{
    margin-top: 48px;
    width:170px;
}
.footer p{
  font-family: "Noto Serif JP";
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.06em;
  text-align: center;
  color: #433a2c;
  margin-top: 34px;
}
</style>